import { Button } from 'components/button/Button';
import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

export const defaultButtonStyle = css`
    font-size: 1.4rem;
    font-weight: 500;
    min-width: 100px;
    padding: 14px 20px;
    background: ${tokens.primary.default};
    color: ${tokens.on.primary};

    &:hover {
        background: ${tokens.button.primaryBackgroundHover};
    }

    &:disabled {
        color: ${tokens.action.disabled};
        background: ${tokens.action.disabledBackground};
    }
`;

export const DefaultButton = styled(Button)`
    ${defaultButtonStyle}
`;
